import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap'
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt, faClipboardCheck, faTrash, faCopy } from '@fortawesome/free-solid-svg-icons';
import tema from "../../services/Plantilla";
import Modat from "../ui-kits/modal";


class Listar extends React.Component {
    constructor(props) {
        super(props);

    }


    state = {
        load: '',
        datosCargados: false,
        roles: [],
        Modulos: [],
        Permisos: [],
        pagina: 0,
        ultimo: 1,
        actual: 1,
        rol_actual: localStorage.getItem('rol')
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Rol?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("roles/delroles/" + id)
                    .then((datosRespuesta) => {
                        
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarRoles(1);
                    })
                    .catch();
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    copy = (id) => {
        Swal.fire({
            title: 'Está seguro de copiar este Rol?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Copiar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("roles/copyroles/" + id)
                    .then((datosRespuesta) => {
                        
                        Swal.fire('COPIAR!', datosRespuesta.data.msj, 'success')
                        this.ListarRoles(1);
                    })
                    .catch();
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    ListarRoles(page) {
        // Validar que page sea un número válido
        if (page < 1) page = 1;
        
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("roles/index/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                
                // Validar que haya datos antes de actualizar el estado
                if (datosRespuesta.data.data && datosRespuesta.data.data.data) {
                    const total = datosRespuesta.data.data.total || 0;
                    const last_page = datosRespuesta.data.data.last_page || 1;
                    const current_page = datosRespuesta.data.data.current_page || 1;
                    
                    // Si la página solicitada es mayor que la última página disponible
                    if (page > last_page) {
                        // Mostrar la última página disponible
                        this.ListarRoles(last_page);
                        return;
                    }
                    
                    this.setState({ 
                        datosCargados: true, 
                        load: '', 
                        roles: datosRespuesta.data.data.data, 
                        pagina: total, 
                        ultimo: last_page, 
                        actual: current_page 
                    });
                }
            })
            .catch();
    }
    ListarPermisos(id) {
        Swal.showLoading();

        authAxios.get("roles/permisos/" + id)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                
                this.setState({ Permisos: datosRespuesta.data.data });
            })
            .catch();
        //window.location.href = '/'; window.localStorage.clear();
    }
    pasar = (id) => {
        document.getElementById('id_rol').value = id;
        this.ListarPermisos(id);


    }
    modulos = () => {
        authAxios.get("roles/modulos")
            .then((datosRespuesta) => {
                
                var status = datosRespuesta.data.status;
                

                this.setState({ Modulos: datosRespuesta.data.data });
            })
            .catch();
    }
    verPermiso = (id) => {

        authAxios.get("roles/verpermisos/" + id)
            .then((datosRespuesta) => {

                var status = datosRespuesta.data.status;
                
                var f = datosRespuesta.data;
                
                document.getElementById('id_modulo').value = f.id_modulo;
                document.getElementById('registrar').value = f.registrar;
                document.getElementById('editar').value = f.editar;
                document.getElementById('eliminar').value = f.eliminar;
                document.getElementById('consultar').value = f.consultar;
                document.getElementById('cargar').value = f.cargar;
                document.getElementById('id').value = id;

            })
            .catch();
    }
    borrarPermiso = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Permiso?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("roles/delpermiso/" + id)
                    .then((datosRespuesta) => {
                        
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarPermisos(document.getElementById('id_rol').value);
                    })
                    .catch();
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    save() {
        var datos = new FormData(document.getElementById("form_roles"));
        
        authAxios.post("roles/addpermisos", datos)
            .then((datosRespuesta) => {
                
                var status = datosRespuesta.data.status;
                
                this.ListarPermisos(document.getElementById('id_rol').value);
                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'Permiso!',
                        datosRespuesta.data.msj,
                        'success'
                    )

                } else {
                    Swal.fire(
                        'Permiso!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch()
    }
    LinkEditar(ide) {
        localStorage.setItem('ide', ide);
        
        window.location.href = process.env.PUBLIC_URL + '/roles/editar/Dubai';
    }
    CambiarPermiso(id, campo) {
        var che = document.getElementById(campo + id);
        var valor = 0;
        if (che.checked == true) {
            valor = 1;
        }
        Swal.showLoading();

        authAxios.get("roles/uppermiso/" + id + '/' + campo + '/' + valor)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                
                this.ListarPermisos(document.getElementById('id_rol').value);
            })
            .catch();

    }

    componentDidMount() {
        this.ListarRoles(1);
        this.modulos();
    }
    
    // Nueva función para manejar el cambio de página de forma segura
    handlePageChange = (page) => {
        const { actual, ultimo } = this.state;
        
        // Validaciones para evitar páginas inválidas
        if (page === 'prev' && actual > 1) {
            this.ListarRoles(actual - 1);
        } else if (page === 'next' && actual < ultimo) {
            this.ListarRoles(actual + 1);
        } else if (page === 'first' && actual > 1) {
            this.ListarRoles(1);
        } else if (page === 'last' && actual < ultimo) {
            this.ListarRoles(ultimo);
        } else if (typeof page === 'number' && page >= 1 && page <= ultimo) {
            this.ListarRoles(page);
        }
    }
    
    // Función para generar números de página
    generatePageNumbers = () => {
        const { actual, ultimo } = this.state;
        let pages = [];
        
        // Mostrar máximo 5 páginas alrededor de la actual
        let startPage = Math.max(1, actual - 2);
        let endPage = Math.min(ultimo, actual + 2);
        
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <li className={`page-item ${i === actual ? 'active' : ''}`} key={i}>
                    <button className="page-link" onClick={() => this.handlePageChange(i)}>
                        {i}
                    </button>
                </li>
            );
        }
        
        return pages;
    }

    // Función para filtrar roles según el rol_actual
    filtrarRolesPorRol = (roles) => {
        const { rol_actual } = this.state;
        
        // Convertir a número para comparación segura
        const rolActualNum = parseInt(rol_actual);
        
        // Si rol_actual es igual a 1, mostrar todos los roles
        if (rolActualNum === 1) {
            return roles;
        }
        
        // Si rol_actual es diferente de 1, filtrar para NO mostrar el rol con id === 1
        return roles.filter(rol => rol.id !== 1);
    }

    render() {
        const { load, roles, pagina, ultimo, actual, Modulos, Permisos, modal, rol_actual } = this.state;
        
        // Aplicar el filtro de roles según el rol_actual
        const rolesFiltrados = this.filtrarRolesPorRol(roles);
        
        return (

            <div className="content">
                <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Asignacion de permisos</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <form id="form_roles">
                                                <div className="row g-3">
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Modulo</label>
                                                        <input className={"form-control form-control-sm"} type="hidden" name="id_rol" id="id_rol" placeholder="" />
                                                        <input className={"form-control form-control-sm"} type="hidden" name="id" id="id" placeholder="" />
                                                        <select className={"form-control form-control-sm"} name="id_modulo" id="id_modulo">

                                                            <option value="0">Seleccione Modulo</option>
                                                            {
                                                                Modulos.map((item) => (
                                                                    <option key={item.id} value={item.id}>{item.titulo}</option>
                                                                ))
                                                            }

                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Registrar</label>
                                                        <select className={"form-control form-control-sm"} name="registrar" id="registrar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Editar</label>
                                                        <select className={"form-control form-control-sm"} name="editar" id="editar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Eliminar</label>
                                                        <select className={"form-control form-control-sm"} name="eliminar" id="eliminar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Consultar</label>
                                                        <select className={"form-control form-control-sm"} name="consultar" id="consultar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Cargar Archivos</label>
                                                        <select className={"form-control form-control-sm"} name="cargar" id="cargar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Configuracion</label>
                                                        <select className={"form-control form-control-sm"} name="configuracion" id="configuracion">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="cedula">Autorizar</label>
                                                        <select className={"form-control form-control-sm"} name="datos" id="datos">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <button type="button" className="btn btn-primary" onClick={() => this.save()}>Agregar Permiso</button>
                                                </div>
                                            </form>
                                        </div>
                                        <br></br>
                                        <div className="row g-3 table-responsive">
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>

                                                        <th className="align-middle">MENU</th>
                                                        <th className="align-middle">REGISTRAR</th>
                                                        <th className="align-middle">EDITAR</th>
                                                        <th className="align-middle">BORRAR</th>
                                                        <th className="align-middle">VER</th>
                                                        <th className="align-middle">CARGAR</th>
                                                        <th className="align-middle">CONF</th>
                                                        <th className="align-middle">AUTORIZAR</th>
                                                        <th className="align-middle">OPC</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        Permisos.map((item) => (
                                                            <tr key={item.id} >

                                                                <td className="align-middle">{item.titulo}<br></br><span style={{ fontSize: '10px' }}>{item.modulo}</span></td>
                                                                <td className="align-middle"> <input type="checkbox" title='Registrar datos' id={"registrar" + item.id} checked={item.registrar == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'registrar')} /></td>
                                                                <td className="align-middle"><input type="checkbox" title='editar datos' id={"editar" + item.id} checked={item.editar == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'editar')} /></td>
                                                                <td className="align-middle"><input type="checkbox" title='eliminar datos' id={"eliminar" + item.id} checked={item.eliminar == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'eliminar')} /></td>
                                                                <td className="align-middle"><input type="checkbox" title='consultar lista' id={"consultar" + item.id} checked={item.consultar == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'consultar')} /></td>
                                                                <td className="align-middle"><input type="checkbox" title='cargar archivos' id={"cargar" + item.id} checked={item.cargar == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'cargar')} /> </td>
                                                                <td className="align-middle"><input type="checkbox" title='Ver configuracion' id={"configuracion" + item.id} checked={item.configuracion == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'configuracion')} /> </td>
                                                                <td className="align-middle"><input type="checkbox" title='Ver mis datos solamente?' id={"autorizar" + item.id} checked={item.autorizar == '1' ? true : false} onClick={() => this.CambiarPermiso(item.id, 'autorizar')} /> </td>
                                                                <td className="align-middle">

                                                                    {/*  <button type="button" className="btn btn-primary btn-xs" onClick={() => this.verPermiso(item.id)}>
                                                                            <FontAwesomeIcon icon={faEdit} />
                                                                            </button> */}

                                                                    <button type="button" className="btn btn-danger btn-xs" onClick={() => this.borrarPermiso(item.id)}>
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </button>
                                                                </td>

                                                            </tr>

                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>

                            </div>
                        </div>
                    </div>
                </div>




                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/roles/crear/" + tema}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Rol</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Roles</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="ROL" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarRoles(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row table-responsive">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">NOMBRE</th>
                                            <th className="align-middle">DESCRIPCIÓN</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            rolesFiltrados && rolesFiltrados.length > 0 ? (
                                                rolesFiltrados.map((itemRoles) => (
                                                    <tr key={itemRoles.id}>
                                                        <td>{itemRoles.nombre}</td>
                                                        <td>{itemRoles.descripcion}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-xs"
                                                                    onClick={() =>
                                                                        this.LinkEditar(itemRoles.id)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-xs"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemRoles.id)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-warning btn-xs"

                                                                    onClick={() =>
                                                                        this.copy(itemRoles.id)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faCopy} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-info btn-xs"
                                                                    data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                                    onClick={() =>
                                                                        this.pasar(itemRoles.id)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                </button>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">No hay registros</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            
                            {/* Paginación corregida */}
                            {pagina > 0 && (
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        <li className={`page-item ${actual === 1 ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link" 
                                                onClick={() => this.handlePageChange('first')}
                                                disabled={actual === 1}
                                            >
                                                <FontAwesomeIcon icon={faAngleDoubleLeft} />
                                            </button>
                                        </li>
                                        <li className={`page-item ${actual === 1 ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link" 
                                                onClick={() => this.handlePageChange('prev')}
                                                disabled={actual === 1}
                                            >
                                                <FontAwesomeIcon icon={faAngleLeft} />
                                            </button>
                                        </li>
                                        
                                        {this.generatePageNumbers()}
                                        
                                        <li className={`page-item ${actual === ultimo ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link" 
                                                onClick={() => this.handlePageChange('next')}
                                                disabled={actual === ultimo}
                                            >
                                                <FontAwesomeIcon icon={faAngleRight} />
                                            </button>
                                        </li>
                                        <li className={`page-item ${actual === ultimo ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link" 
                                                onClick={() => this.handlePageChange('last')}
                                                disabled={actual === ultimo}
                                            >
                                                <FontAwesomeIcon icon={faAngleDoubleRight} />
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Listar;